// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import TeamDto from 'common/dto-types/team-dto';

type TeamSliceStates = {
    data?: TeamDto;
    isFormOpen: boolean;
    isFetchFdcpFormOpen: boolean;
};

const initialState: TeamSliceStates = {
    isFormOpen: false,
    isFetchFdcpFormOpen: false,
};

const team = createSlice({
    name: 'team',
    initialState,
    reducers: {
        openCreateForm(state) {
            state.isFormOpen = true;
        },

        openFetchFdcpForm(state) {
            state.isFetchFdcpFormOpen = true;
        },

        closeCreateForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },

        closeFetchFdcpForm(state) {
            state.isFetchFdcpFormOpen = false;
        },
    },
});

export default team.reducer;

export const { openCreateForm, openFetchFdcpForm, closeCreateForm, closeFetchFdcpForm } = team.actions;
